export default () => {
    const attributeCertification = document.querySelector('.woocommerce-product-attributes-item--attribute_certificazione');

    if(attributeCertification){
        Array.from(attributeCertification.children).forEach(attribute => {
            if(attribute.className == 'woocommerce-product-attributes-item__value'){
                if(attribute.innerText == "0"){
                    attribute.parentElement.classList.add('not-active');
                } else {
                    attribute.insertAdjacentHTML('beforeend', '<img loading="lazy" class="certificationImage" src="https://cdn.jumpgroup.it/sites/puroebio/uploads/2021/05/euro_green.png">')
                }
            }
        });
    }
  
};
 